var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoley(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 163,
    height: 63,
    viewBox: "0 0 163 63",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16881_459514)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.9398 18.9921C76.9398 28.1049 72.3947 37.6347 62.2076 37.6347C52.0205 37.6347 47.4753 28.1049 47.4753 18.9921C47.4753 9.87935 52.0167 0.349609 62.2076 0.349609C72.3984 0.349609 76.9398 9.87935 76.9398 18.9921ZM54.8189 18.9921C54.8189 23.6424 56.0585 31.9176 62.2076 31.9176C68.3566 31.9176 69.5962 23.6424 69.5962 18.9921C69.5962 14.3418 68.3566 6.0667 62.2076 6.0667C56.0585 6.0667 54.8189 14.3418 54.8189 18.9921Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3534 7.04371H46.559V0.909668H24.1226V37.0754H31.3534V21.8285H43.0806V15.6907H31.3534V7.04371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.288 57.1303C50.9086 56.5068 50.6306 55.8344 50.6306 55.1019C50.6306 53.7722 51.4607 52.5514 53.0008 52.5514C54.1991 52.5514 55.3185 53.528 55.3185 54.7864C55.3185 56.0448 54.5597 56.9125 53.5868 57.5585C54.0376 58.2422 54.5033 58.7906 55.0142 59.2301C55.3673 58.7042 55.5514 58.1783 55.6866 57.6562L57.2116 57.998C57.0426 58.7681 56.7346 59.4855 56.2838 60.1466C56.7609 60.4284 57.2492 60.526 57.7488 60.5598L57.6511 62.2464C56.7722 62.2727 55.9307 61.9647 55.187 61.5027C54.4658 62.0999 53.6469 62.3441 52.7229 62.3441C51.2203 62.3441 49.6089 61.3937 49.6089 59.7447C49.6089 58.6328 50.2174 57.8891 51.0851 57.2768L51.2917 57.1303H51.288ZM52.0355 58.4601C51.6711 58.7155 51.4758 59.0235 51.4758 59.4855C51.4758 60.2781 52.197 60.8416 52.952 60.8416C53.3314 60.8416 53.5981 60.7176 53.9061 60.511H53.9023C53.1586 59.8274 52.4749 59.1437 52.0355 58.4601ZM53.7934 54.8578C53.7934 54.4295 53.5267 53.9788 53.0497 53.9788C52.5501 53.9788 52.2458 54.4295 52.2458 54.8953C52.2458 55.4389 52.4236 55.7724 52.6652 56.2256L52.7229 56.334C53.3802 55.9321 53.7972 55.6128 53.7972 54.8578H53.7934Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2492 57.4495C16.2492 59.8423 15.0397 62.344 12.3314 62.344C9.6231 62.344 8.41357 59.8423 8.41357 57.4495C8.41357 55.0568 9.6231 52.5551 12.3314 52.5551C15.0397 52.5551 16.2492 55.0568 16.2492 57.4495ZM10.3669 57.4495C10.3669 58.6703 10.6974 60.8452 12.3314 60.8452C13.9654 60.8452 14.2959 58.6703 14.2959 57.4495C14.2959 56.2287 13.9654 54.0538 12.3314 54.0538C10.6974 54.0538 10.3669 56.2287 10.3669 57.4495Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.14109 54.3089H2.13687V56.5777H5.22455V58.1892H2.13687V62.1934H0.232422V52.6937H6.14109V54.3089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7458 60.5857H20.7904V52.6975H18.886V62.1972H24.7458V60.5857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1076 54.3089H29.1034V56.5777H32.424V58.1892H29.1034V60.582H33.3405V62.1934H27.199V52.6937H33.1076V54.3089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.297 62.1934V58.362H40.2932L43.4448 52.6975H41.4802L39.3579 56.8745L37.307 52.6975H35.2786L38.3925 58.362V62.1934H40.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0276 60.5857H67.0722V52.6975H65.1677V62.1972H71.0276V60.5857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.1956 62.1972H79.2574L78.6338 59.8157H75.8241L75.2006 62.1972H73.2585L75.9218 52.6975H78.4836L81.1956 62.1972ZM77.2552 54.3353H77.2064L76.2072 58.3132H78.2582L77.2552 54.3353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5977 55.4697C90.5977 54.2601 89.745 52.6975 87.5588 52.6975H83.8101V62.1972H85.7145V58.2531H87.1682L88.8773 62.1972H90.8794L88.9862 57.8624C89.9516 57.4718 90.5977 56.5064 90.5977 55.4697ZM86.6398 56.6418L86.5446 56.6416V56.6454H85.7145V54.3127H86.4207C86.4889 54.3127 86.5588 54.3121 86.6299 54.3115C87.5421 54.3038 88.6444 54.2946 88.6444 55.5072C88.6444 56.6461 87.4682 56.6436 86.6398 56.6418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.2247 52.6975C99.8383 52.6975 101.119 54.7484 101.119 57.4454C101.119 60.1425 99.7143 62.1934 96.8821 62.1934H93.9033V52.6937H96.221L96.2247 52.6975ZM96.7393 60.5857C98.2531 60.5857 99.1697 59.6316 99.1697 57.2276C99.1697 55.2367 98.3132 54.3089 96.5327 54.3089H95.8115V60.5857H96.7393Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.935 58.9593L107.092 52.6975H104.308V62.1972H106.213V54.5681H106.235L109.826 62.1972H111.866V52.6975H109.962V58.9593H109.935Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.144 54.3089H117.14V56.5777H120.46V58.1892H117.14V60.582H121.377V62.1934H115.235V52.6937H121.144V54.3089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.395 55.4697C131.395 54.2601 130.542 52.6975 128.356 52.6975H124.607V62.1972H126.512V58.2531H127.965L129.674 62.1972H131.677L129.783 57.8624C130.749 57.4718 131.395 56.5064 131.395 55.4697ZM127.437 56.6418L127.342 56.6416L127.346 56.6454H126.515V54.3127H127.222C127.289 54.3127 127.359 54.3121 127.43 54.3115C128.339 54.3038 129.442 54.2945 129.442 55.5072C129.442 56.6461 128.265 56.6436 127.437 56.6418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.052 60.5857H146.007V62.1972H140.147V52.6975H142.052V60.5857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.722 60.5857H149.767V52.6975H147.863V62.1972H153.722V60.5857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.241 52.6975C161.449 52.6975 162.366 54.3202 162.366 55.6875C162.366 57.1262 161.509 58.5573 158.763 58.5573H157.483V62.1972H155.578V52.6975H159.241ZM157.873 56.9459C157.968 56.9459 158.067 56.9473 158.169 56.9488C159.173 56.9636 160.412 56.9818 160.412 55.6274C160.412 54.2731 159.173 54.2913 158.169 54.306C158.119 54.3067 158.07 54.3075 158.021 54.308C157.971 54.3086 157.922 54.309 157.873 54.309H157.483V56.9459H157.873Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.595 30.9413H88.0284V0.909668H81.0154V37.0791H102.595V30.9413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.081 7.04371H113.917V15.6907H126.493V21.8285H113.917V30.9413H129.96V37.0791H106.705V0.909668H129.081V7.04371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.766 37.0754V22.4821L162.666 0.909668H155.24L147.213 16.8101L139.463 0.909668H131.808L143.573 22.4784V37.0754H150.766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.317 0.977295H0.356445V16.4833H16.317V0.977295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.356445 21.4379H16.317V36.9739H0.356445V21.4379Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16881_459514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 162.786,
    height: 62.6819,
    fill: "white",
    transform: "translate(0 0.158203)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoley);
export default __webpack_public_path__ + "static/media/foley.6531163d166a0f1adfab91fd7a1f9f51.svg";
export { ForwardRef as ReactComponent };